import styled from "styled-components";

export const Footer = styled.footer`
  background-color: #bbc2d3;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;

  & > h2 {
    margin: 0.5rem 0 5rem 0;
    font-size: 1.4rem;
  }

  & > p {
    color: #ebf1ff;
    /* font-size: 1rem; */
    /* line-height: 23px; */
  }
`;
